export * from './lib/interfaces/places-autocomplete-form-field-config.interface';
export * from './lib/interfaces/places-autocomplete-template-options.interface';

export * from './lib/form-places-autocomplete.module';
